<template>
  <v-col md="3">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6" v-text="$t('Dashboard.headingCustomSpends')"></div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="Add" @click="toggleSpendModalBtn(true)">
              <span v-text="$t('Dashboard.add')"></span>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="py-0">
        <bar-chart v-if="data"
            :data="buildChart"
            :options="option"
            :style="{ height: '300px' }"
            class="pt-5"
            id='Chart'
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import colors from "vuetify/lib/util/colors";
import BarChart from "@/components/ChartJS/BarChart";
export default {
  components: { BarChart },
  computed : {
    ...mapGetters(["user"]),
    buildChart(){
      this.data.labels = this.user.d_charts.labels_expense;
      this.data.datasets=[];
      let charts=['Fees'];
      charts.forEach( e =>
      {                  
        if (this.user.d_charts[e])
        {
          if (this.user.d_charts[e].reduce((a, b) => a + b, 0)>0) 
          {
            this.empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
            this.empty_dataset.data = this.user.d_charts[e];
            this.empty_dataset.backgroundColor= e=='COGS'?colors.mygreen.darken2:colors.mygreen.lighten2;
            //this.empty_dataset.gradientFill= lc[e];
            this.data.datasets.push(JSON.parse(JSON.stringify(this.empty_dataset)));
          }
        }
      });
      return this.data;
    },
  },
  data() {
    return {
      namespace: "Dashboard",
      page: "Dashboard",
      loading:false,
      timeframe_dialog: false,
      errorid: null,
      search: '',
      showingTasks: "Add",
      orders: null,
      enabled_eBayAccounts: [],
      totalrevenue: null,
      empty_dataset:
      {
        label: '',
        backgroundColor: colors.mygreen.darken2,
        data: [12, 17, 5, 19],
        shadowOffsetX: 2,
        shadowOffsetY: 4,
        shadowBlur: 8,
        shadowColor: "rgba(66, 165, 245, 0.5)",
        categoryPercentage: 0.5,
        barPercentage: 0.5,
      },
      data: 
      {
        labels: null,
        datasets: null
      },
      option: 
      {
        responsive: true,
        scaleOverride: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "nearest",
          backgroundColor:'rgba(255,255,255,0.85)',
          titleFontColor:'#333',
          bodyFontColor: '#333',
          xPadding:15,
          yPadding:15,
          intersect: true,
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
        legend: {
          display: true,
          position:'bottom',
          align: 'start',
          labels:{
            boxWidth: 5,
            usePointStyle: true
          },
          intersect: false,
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            bottom: 10,
            top: 10,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
              },
              zeroLineWidth: 1,
            }
          ],
          yAxes: [
            {
             id:1,
             position: 'left',
             display: true,
             zeroLineWidth: 1,
             scalePositionLeft: true,
             ticks: {
                beginAtZero: true
              },
              gridLines: {
                offsetGridLines: false
              }
            },
          ]
        }
      },
     };
  },
  methods:
  {
    toggleSpendModalBtn(v)
    {
      console.log('toggleSpendModal',v);
      this.$store.dispatch("toggleSpendModal",v); 
    },
  },
  beforeDestroy() {
    this.chartProperties = null;
    delete this.chartProperties;
  },
}
</script>